/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  app.CartRouter = app.Router.extend({
    mode: 'server',
    /**
     * @inheritDoc
     */
    initialize: function (options) {
      app.Router.prototype.initialize.apply(this, arguments);

      /**
       * Передаем в app.cart себя
       */
      if (options.collection instanceof app.Cart) {
        if (typeof options.collection.setRouter === 'function') {
          options.collection.setRouter(this);
        }
      }
    },
    /**
     * @inheritDoc
     */
    handleRoute: function (page) {
      var params = app.helpers.UrlHelper.getUrlParameters(),
        that = this,
        defaults = {
          'sort': this.collection.defaults.sort,
          'per-page': this.collection.defaults.pageSize,
          'viewtype': this.collection.defaults.viewtype,
          'f': this.collection.defaults.f,
          'mode': this.mode,
          'correct': this.collection.defaults.correct,
          'q': this.collection.query,
          'qc': this.collection.defaults.qc,
          'currency': this.currency.name
        };
      // Валидируем полученные из урла параметры
      _.each(params, function (param, key) {
        if (key === 'per-page') {
          var allowedPageSize = app.features.is_stripped_per_page_segments ? [20] : [20, 50, 100];
          param = parseInt(param, 10);
          if (allowedPageSize.indexOf(param) === -1) {
            param = that.collection.state.pageSize;
          }
        }
        return _.indexOf(that.allowed, key) >= 0 ? params[key] = param : params[key] = defaults[key];
      });
      _.defaults(params, defaults);
      // Перезаписываем все ссылки на странице
      if (app.bodyView) {
        app.bodyView.rewritePageLinks();
      }
      page = parseInt(page, 10);
      if (!page) {
        page = 1;
      }
      if (params.mode !== this.mode) {
        if (this.collection.sort !== params.sort) {
          this.collection.setSort(params.sort);
        }
        this.mode = params.mode;
        this.collection.setPageSize(params['per-page'], {fetch: true}, page);
        this.trigger('change-mode');
        return;
      }
      if (this.collection.state.pageSize !== params['per-page']) {
        if (this.collection.sort !== params.sort) {
          this.collection.setSort(params.sort);
          this.trigger('change-sort');
        }
        this.infiniteFetch();
        this.collection.setPageSize(params['per-page'], null, page);
        this.trigger('change-pagesize');
        return;
      }
      if (this.collection.state.currentPage !== page) {
        if (this.collection.sort !== params.sort) {
          this.collection.setSort(params.sort);
          this.trigger('change-sort');
        }
        this.collection.getPage(page, {fetch: true});
        this.trigger('change-page');
        return;
      }
      if (this.collection.currencyId !== params.currency) {
        if (this.collection.sort !== params.sort) {
          this.collection.setSort(params.sort);
          this.trigger('change-sort');
        }
        this.collection.setCurrency(params.currency);
        this.collection.getPage(page, {fetch: true});
        this.trigger('change-currency');
        if (this.mode === 'infinite') {
          this.infiniteFetch();
        }
        return;
      }
      if (this.collection.sort !== params.sort) {
        this.collection.setSort(params.sort);
        this.collection.getPage(1, {fetch: true});
        this.trigger('change-sort');
        if (this.mode === 'infinite') {
          this.infiniteFetch();
        }
        return;
      }
      this.collection.getPage(this.collection.state.currentPage);
    }
  });
}());

}.call(window));